import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';

// jwt auth
const LoginPage     = Loadable(lazy(() => import('pages/auth/Login')));
const RegisterPage  = Loadable(lazy(() => import('pages/auth/Register')));
const ForgotPwdPage = Loadable(lazy(() => import('pages/auth/ForgotPassword')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      children: [
        {
          path: '/',
          element: <LoginPage />
        },
        {
          path: '/login',
          element: <LoginPage />
        },
        {
          path: '/register',
          element: <RegisterPage />
        },
        {
          path: '/forgot_password',
          element: <ForgotPwdPage />
        }
      ]
    }
  ]
};

export default LoginRoutes;
